import { isSurfacedFinding } from '../../../netlify/functions/lib/bug-management/statuses'
import { summarizeBugs, uniqueBugs } from './bugSummary'

/** Classify a run's surfaced findings (Q2); rediscoveries do not fail a clean revision. */
export function testRunFindings<T extends { id: string; is_duplicate?: boolean; status?: string }>(findings: readonly T[]) {
  const all = uniqueBugs(findings.filter(finding => isSurfacedFinding(finding.status)))
  return {
    new_bugs: all.filter(finding => !finding.is_duplicate),
    rediscoveries: all.filter(finding => finding.is_duplicate),
  }
}

/** Normalize legacy association arrays and current sessions through the same read model. */
export function sessionBugData<T extends { id: string; is_duplicate?: boolean; status?: string; severity?: string }>(session: {
  bugs: readonly T[]
  bug_associations?: readonly T[]
}) {
  const bug_associations = (session.bug_associations ?? session.bugs).filter(bug => isSurfacedFinding(bug.status))
  const bugs = uniqueBugs(bug_associations)
  return { bugs, bug_associations, bug_summary: summarizeBugs(bugs), findings: testRunFindings(bugs) }
}
